import { NgModule } from '@angular/core';
import { HeaderComponent } from './header/header.component';
import { CommonModule } from '@angular/common';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { NavbarComponent } from './navbar/navbar.component';
import { UserComponent } from './modules/shared-components/user/user.component';
import { MainNavComponent } from './modules/shared-components/main-nav/main-nav.component';
import { RouterModule } from '@angular/router';
import { AlertModule } from './alert/alert.module';
import { AutoCompleteModule } from './modules/shared-components/auto-complete/auto-complete.module';
import { MomentModule } from 'ngx-moment';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { AngularMultiSelectModule } from 'angular2-multiselect-dropdown';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NzTreeSelectModule } from 'ng-zorro-antd/tree-select';
import { NzSelectModule } from 'ng-zorro-antd/select';
import { PendingChangesGuard } from './pending-changes-guard';
import { NgxPermissionsModule } from 'ngx-permissions';
import { DndDirective } from './modules/control-centre/products/product-view/edit-product-image/dnd.directive';
import { VersionComponent } from './version/version.component';
import { VersionModalComponent } from './version/version-modal/version-modal.component';
import { AutofocusDirective } from './modules/shared-components/autofocus.directive';
import { ImageSelectorComponent } from './modules/shared-components/image-selector/image-selector.component';
import { TranslateModule } from '@ngx-translate/core';
import { LanguageSettingsComponent } from './header/language-settings/language-settings.component';
import { AddressFormComponent } from './modules/shared-components/address-form/address-form.component';
import { CountryRtlDirective } from './modules/shared-components/country-rtl.directive';
import { AppInitializerLoaderComponent } from './modules/shared-components/app-initializer-loader/app-initializer-loader.component';
import { CommonModalComponent } from './modules/shared-components/common-modal/common-modal.component';
import { CommonTitleComponent } from './modules/shared-components/common-title/common-title.component';
import { CommonActionComponent } from './modules/shared-components/common-action/common-action.component';
import { FileSelectorComponent } from './modules/shared-components/file-selector/file-selector.component';
import { ContentDisplayComponent } from './modules/shared-components/content-display/content-display.component';
import { DatePickerSelectorComponent } from './modules/shared-components/date-picker-selector/date-picker-selector.component';
import { LandingModalComponent } from './landing/landing-modal/landing-modal.component';
import { TwoDigitDecimaNumberDirective } from './modules/shared-components/two-digit-decimal.directive';
import { NgSelectModule } from '@ng-select/ng-select';
import { ApiCallTimerComponent } from './modules/shared-components/api-call-timer/api-call-timer.component';

@NgModule({
  declarations: [
    HeaderComponent,
    NavbarComponent,
    VersionComponent,
    UserComponent,
    MainNavComponent,
    DndDirective,
    VersionModalComponent,
    ImageSelectorComponent,
    AutofocusDirective,
    LanguageSettingsComponent,
    CountryRtlDirective,
    AppInitializerLoaderComponent,
    CommonModalComponent,
    CommonTitleComponent,
    ContentDisplayComponent,
    CommonActionComponent,
    AddressFormComponent,
    FileSelectorComponent,
    DatePickerSelectorComponent,
    LandingModalComponent,
    TwoDigitDecimaNumberDirective,
    ApiCallTimerComponent
  ],
  imports: [
    CommonModule,
    NgbModule,
    RouterModule,
    AlertModule,
    AutoCompleteModule,
    MomentModule,
    FontAwesomeModule,
    AngularMultiSelectModule,
    FormsModule,
    ReactiveFormsModule,
    NzTreeSelectModule,
    NzSelectModule,
    NgxPermissionsModule,
    TranslateModule,
    NgSelectModule
  ],
  exports: [
    HeaderComponent,
    NavbarComponent,
    UserComponent,
    MainNavComponent,
    ImageSelectorComponent,
    DndDirective,
    AutofocusDirective,
    AlertModule,
    AutoCompleteModule,
    NgbModule,
    MomentModule,
    FontAwesomeModule,
    AngularMultiSelectModule,
    FormsModule,
    NzTreeSelectModule,
    NzSelectModule,
    NgxPermissionsModule,
    TranslateModule,
    LanguageSettingsComponent,
    CountryRtlDirective,
    AppInitializerLoaderComponent,
    CommonModalComponent,
    CommonTitleComponent,
    CommonActionComponent,
    ContentDisplayComponent,
    AddressFormComponent,
    FileSelectorComponent,
    DatePickerSelectorComponent,
    TwoDigitDecimaNumberDirective,
    NgSelectModule,
    ApiCallTimerComponent
  ],
  providers: [PendingChangesGuard]
})
export class SharedModule { }
